// axios
import axios from 'axios'
import Vue from 'vue'

const axiosIns = axios.create({

  // baseURL: 'https://api.aerohotel.chesshotel.ocatech.com.br/api/',
  // baseURL: 'http://chess-hotel.test/api/',
  baseURL: process.env.VUE_APP_URL_API,
  timeout: 30000,

})

axiosIns.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (!config.headers.Authorization) {
      const accessToken = localStorage.getItem('accessToken')

      // eslint-disable-next-line no-param-reassign
      if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  error => {
    console.log('erro request')
  },
)

axiosIns.interceptors.response.use(
  config => {
    // Do something before request is sent
    if (!config.headers.Authorization) {
      const accessToken = localStorage.getItem('accessToken')

      // eslint-disable-next-line no-param-reassign
      if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  error => {
    console.log('error response')

    // Sem error.response = timeout, sem internet ou CORS/servidor fora do ar
    if (!error.response) {
      if (error.code === 'ECONNABORTED') {
        Vue.$toast.error('Tempo de conexão esgotado. Tente novamente.')
      } else if (!window.navigator.onLine) {
        Vue.$toast.error('Sem conexão com a internet.')
      } else {
        Vue.$toast.error('Não foi possível conectar ao servidor.')
      }

      return Promise.reject(error)
    }

    if (error.response.config.headers.callbackerror == undefined) {
      switch (error.response.status) {
        case 422:
        // intercepta erro 422
          var errors = error.response.data

          var html = ''
          if (typeof (errors) === 'object') {
          // Verifica se tem errors.errors (validação de formulário)
            if (errors.errors) {
              for (const error in errors.errors) {
                html += `<p>${errors.errors[error]}</p>`
              }
            }

            // Verifica se tem message direto (validação de regra de negócio)
            else if (errors.message) {
              html = errors.message
            }
          }
          if (typeof (errors) === 'string') {
            html = errors
          }

          Vue.swal({
            confirmButtonColor: '#16b1ff',
            position: 'center',
            html,
            icon: 'error',
            title: 'Erro',
          })
          break
        case 400:
        // intercepta erro 422
          var errors = error.response.data

          var html = ''
          if (typeof (errors) === 'object') {
            if (errors.errors) {
              for (const error in errors.errors) {
                html += `<p>${errors.errors[error]}</p>`
              }
            } else if (errors.message) {
              html = errors.message
            }
          }
          if (typeof (errors) === 'string') {
            html = errors
          }

          Vue.swal({
            confirmButtonColor: '#16b1ff',
            position: 'center',
            html,
            icon: 'error',
            title: 'Erro',
          })
          break
        case 401:
        // intercepta erro 401
          Vue.$toast.error('Não autorizado')
          break
        case 403:
        // intercepta erro 403
          Vue.$toast.error('Não autorizado')
          break
        case 423:
          {
            const { message } = error.response.data || {}
            Vue.$toast.error(message || 'Auditoria pendente')
          }
          break
        case 500:
        // intercepta erro 500
          Vue.$toast.error('Erro no servidor')
          break

        default:
          Vue.$toast.error('Erro inesperado')
          break
      }
    }

    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
